import { render } from "./BaseCross.vue?vue&type=template&id=39ebb443&scoped=true"
import script from "./BaseCross.vue?vue&type=script&lang=js"
export * from "./BaseCross.vue?vue&type=script&lang=js"

import "./BaseCross.vue?vue&type=style&index=0&id=39ebb443&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ebb443"]])

export default __exports__